import React, { useEffect } from 'react';

import Button from 'components/Ui/Button';
import { useAuth0 } from 'auth0Provider';
import { isSsr } from 'utils/ssrHelper';
import styles from './styles.scss';

const RedirectLandingPage = () => {
  const { loginWithRedirect, loading } = useAuth0();
  useEffect(() => {
    const windowIsDefined = !isSsr();
    const urlQueryStr = windowIsDefined && window.location.search;
    if (urlQueryStr) {
      const params = new URLSearchParams(urlQueryStr);
      const skipLandingParam = params.get('skipLanding');
      const skipLanding = skipLandingParam === 'true';

      if (windowIsDefined && skipLanding && !loading) {
        loginWithRedirect();
      }
    }
  }, [loading]);

  return (
    <main className={styles.redirectLanding}>
      <h1>Welcome to the new Crystal Rock Experience</h1>
      <h2>Please click continue to proceed...</h2>
      <Button
        className={styles.continueButton}
        onClick={loginWithRedirect}
        text="Continue"
      />
    </main>
  );
};

export default RedirectLandingPage;
